import React from 'react'
import styled from 'styled-components'

const StyledChat = styled.div`
    display: flex;
    flex-direction: column;
    width: 500px;
    background-color: red;
    &:hover {
        cursor: pointer;
    }
`

const ChatShort = ({ conversation, onClick }) => {
    return (
        <StyledChat onClick={onClick}>
            <h3>{conversation.thingTitle}</h3>
            <p>
                Dernier message : {conversation.lastMessage || 'Aucun message'}
            </p>
            <p>
                Dernière activité :{' '}
                {new Date(conversation.lastMessageTime).toLocaleString()}
            </p>
        </StyledChat>
    )
}

export default ChatShort
